<script setup>
import { useStore } from 'vuex';
import DsLinkBlock from 'JIX/components/ds/DsLinkBlock.vue';
import { __ } from 'JIX/gettext.js';
import 'icons/category.svg';
import 'icons/filter.svg';
import 'icons/close.svg';
import 'icons/service-jobsearch.svg';

const store = useStore();

async function showUnsolicitedMode(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return store.dispatch('performSearch', { newViewMode: 'unsolicited' });
}

async function showAnalysisMode(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return store.dispatch('performSearch', { newViewMode: 'analysis' });
}
</script>

<template>
    <section class="jobsearch-bottom-section">
        <div class="container jobsearch-bottom-section__container">
            <div class="jobsearch-bottom-section__box" v-if="store.state.viewMode !== 'analysis'">
                <div class="h-100">
                    <div class="d-none d-sm-flex justify-content-center jobsearch-bottom-section__illustration-background">
                        <img
                            src="/img/jobindex20/jobsearch/search-jobdk.svg?v=3"
                            alt="Statistik illustration"
                            class="jobsearch-bottom-section__illustration ml-n4"
                        >
                    </div>
                    <div class="pr-3 pl-3 pt-3">
                        <h5>{{ __("Statistik for denne søgning") }}</h5>
                        <p>{{ __("Hvor mange af denne type job har der været de seneste år? Hvor i landet er der flest job? Hvilken virksomhed slår flest stillinger op? Hold øje med jobmarkedet her.") }}</p>
                    </div>
                </div>
                <DsLinkBlock
                    class="pr-3 pl-3 pb-3"
                    link-class="stretched-link"
                    :href="store.state.searchResponse.link_subpages.analysis"
                    @click.prevent="showAnalysisMode"
                >
                    {{ __("Se statistik") }}
                </DsLinkBlock>
            </div>
            <div class="jobsearch-bottom-section__box">
                <div class="h-100">
                    <div class="d-none d-sm-flex justify-content-center jobsearch-bottom-section__illustration-background">
                        <img
                            src="/img/jobindex20/jobsearch/cv-jobdk.svg?v=2"
                            alt="CV illustration"
                            class="jobsearch-bottom-section__illustration jobsearch-bottom-section__illustration-cv"
                        >
                    </div>
                    <div class="pr-3 pl-3 pt-3">
                        <h5>{{ __("Bliv kontaktet med job") }}</h5>
                        <p>{{ __("Opret et CV og bliv kontaktet af rekrutteringskonsulenter med job, der matcher din profil og dine jobønsker.") }}</p>
                    </div>
                </div>
                <DsLinkBlock
                    class="pr-3 pl-3 pb-3"
                    link-class="stretched-link"
                    :href="store.state.urls.cv_default + '?source=jobsearch'"
                >
                    {{ __("Opret CV") }}
                </DsLinkBlock>
            </div>
            <div class="jobsearch-bottom-section__box" v-if="store.state.viewMode !== 'unsolicited'">
                <div class="h-100">
                    <div class="d-none d-sm-flex justify-content-center jobsearch-bottom-section__illustration-background">
                        <img
                            src="/img/jobindex20/jobsearch/apply-jobdk.svg?v=2"
                            alt="Ansøg illustration"
                            class="jobsearch-bottom-section__illustration jobsearch-bottom-section__illustration-apply"
                        >
                    </div>
                    <div class="pr-3 pl-3 pt-3">
                        <h5>{{ __("Søg uopfordret") }}</h5>
                        <p>{{ __("Vi har samlet en liste af virksomheder, der tidligere har søgt medarbejdere, der matcher din søgning. Du kunne måske søge uopfordret hos dem?") }}</p>
                    </div>
                </div>
                <DsLinkBlock
                    class="pr-3 pl-3 pb-3"
                    link-class="stretched-link"
                    :href="store.state.searchResponse.link_subpages.unsolicited"
                    @click.prevent="showUnsolicitedMode"
                >
                    {{ __("Se virksomheder") }}
                </DsLinkBlock>
            </div>
        </div>
    </section>
</template>
